// Country catalog — transforms raw JSON to dropdown options
import countriesData from './countriesData.json';

export interface CatalogOption {
  value: string;
  label: string;
}

// Raw country entry from JSON
interface RawCountry {
  id: number;
  name: string;
  iso2: string;
}

// Pre-built options list sorted alphabetically by name
export const countries: CatalogOption[] = (countriesData as RawCountry[])
  .map((c) => ({ value: c.iso2, label: c.name }))
  .sort((a, b) => a.label.localeCompare(b.label));

// Lookup: country id → iso2 code (used by cities transformer)
export const countryIdToCode = new Map<number, string>(
  (countriesData as RawCountry[]).map((c) => [c.id, c.iso2])
);
